import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import DomainDetailsSendersTab from './domain-details-tab-senders';

import { openVerificationBySenderModal } from '../common/actions/modal-action-creators';

export class DomainDetailSendersTabContainer extends Component{
    render(){
        const { domainName, sendersData, openVerificationBySenderModal } = this.props;
        return (
            <DomainDetailsSendersTab
                onEdit={openVerificationBySenderModal}
                domainName={domainName}
                sendersData={sendersData}
            />
        );
    }
}

DomainDetailSendersTabContainer.propTypes = {
    domainName: PropTypes.string.isRequired,
    openVerificationBySenderModal: PropTypes.func.isRequired,
    sendersData: PropTypes.array.isRequired,
};

export default connect(
    null,
    { openVerificationBySenderModal }
)( DomainDetailSendersTabContainer );
